export const RemotePlayerInteractableEventTypes = {
  OnHover: "interactableonremoteplayerhover",
  OnInteract: "interactableonremoteplayerinteract",
  OnOut: "interactableonremoteplayerout",
};
